// src/Pages/DistrictAdminReport.jsx
import { useState, useEffect } from "react";
import { Button, Table, Spin, Alert, message, Modal, Space } from "antd";
import {
    FileExcelOutlined,
    ReloadOutlined,
    FilePdfOutlined,
} from "@ant-design/icons";
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
    getAdminDistrictSpecialGsReport,
    getBlocksummaryforadmin,
    getAdminGpSummaryReport
} from "../api/User";

const DistrictAdminReport = ({ dateFilter }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    /* -------- Block Modal -------- */
    const [blockModalOpen, setBlockModalOpen] = useState(false);
    const [blockModalTitle, setBlockModalTitle] = useState("");
    const [blockData, setBlockData] = useState([]);
    const [blockLoading, setBlockLoading] = useState(false);

    /* -------- GP Modal -------- */
    const [gpModalOpen, setGpModalOpen] = useState(false);
    const [gpModalTitle, setGpModalTitle] = useState("");
    const [gpData, setGpData] = useState([]);
    const [gpLoading, setGpLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [blockPage, setBlockPage] = useState(1);
    const [blockPageSize, setBlockPageSize] = useState(10);

    const [gpPage, setGpPage] = useState(1);
    const [gpPageSize, setGpPageSize] = useState(10);
    const numberSorter = (a, b, key) => {
        const valA = a[key] || 0;
        const valB = b[key] || 0;
        return valA - valB;
    };

    // Helper function for string sorting
    const stringSorter = (a, b, key) => {
        const valA = (a[key] || '').toString().toLowerCase();
        const valB = (b[key] || '').toString().toLowerCase();
        return valA.localeCompare(valB);
    };


    /* ================= MAIN TABLE COLUMNS ================= */
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            key: "district_name",
            width: 160,
            align: "center",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
            ellipsis: true,

        },
        {
            title: "No. of Blocks",
            dataIndex: "block_count",
            key: "block_count",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'block_count'),

            render: (val, record) => (
                <span onClick={() => openBlockModal(record)} style={clickStyle}>
                    {val || 0}
                </span>
            ),
        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "gp_count",
            key: "gp_count",
            width: 160,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gp_count'),

            render: (val, record) => (
                <span onClick={() => openGPFromDistrict(record)} style={clickStyle}>
                    {val || 0}
                </span>
            ),
        },
        {
            title: "Gram sabha Held (including 1st,2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            key: "gram_sabha_held",
            width: 200,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_fulfilled",
            key: "quorum_fulfilled",
            width: 180,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_failed",
            key: "quorum_failed",
            width: 160,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),

            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            key: "never_scheduled_gs",
            width: 180,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),

            render: (val) => <span>{val || 0}</span>,
        },
    ];

    /* ================= BLOCK MODAL COLUMNS ================= */
    const blockColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),

        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),

        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 180,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),

        },
        {
            title: "No. of Gram Panchayats",
            dataIndex: "gp_count", // This is now no_of_gram_panchayats
            width: 150,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gp_count'),
            render: (value, record) => (
                <span onClick={() => openGPFromBlock(record)} style={clickStyle}>
                    {value || 0}
                </span>
            ),
        },
        {
            title: "Gram Sabha Held (including 1st,2nd & 3rd)",
            dataIndex: "gram_sabha_held", // This is now total_panchayats_gramsabha_held
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_fulfilled", // This is now quorum_fulfilled_count
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),

            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_failed", // This is now quorum_failed_count
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),

            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs", // This is now never_scheduled_gramsabha
            width: 140,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),

            render: (val) => <span>{val || 0}</span>,
        },
    ];

    /* ================= GP MODAL COLUMNS ================= */
    const gpColumns = [
        {
            title: "Sr. No.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 60,
            align: "center",
            fixed: "left",
            sorter: (a, b) => numberSorter(a, b, 'sr_no'),
        },
        {
            title: "District Name",
            dataIndex: "district_name",
            width: 120,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'district_name'),
        },
        {
            title: "Block Name",
            dataIndex: "block_name",
            width: 140,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'block_name'),
        },
        {
            title: "Gram Panchayat Name",
            dataIndex: "gp_name",
            width: 200,
            align: "center",
            fixed: "left",
            sorter: (a, b) => stringSorter(a, b, 'gp_name'),
        },
        {
            title: "Gram Sabha Held (including 1st,2nd & 3rd)",
            dataIndex: "gram_sabha_held",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'gram_sabha_held'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Fulfilled (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_fulfilled",
            width: 120,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_fulfilled'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Quorum Failed (including 1st,2nd & 3rd meeting)",
            dataIndex: "quorum_failed",
            width: 110,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'quorum_failed'),
            render: (val) => <span>{val || 0}</span>,
        },
        {
            title: "Never Scheduled Gram Sabha",
            dataIndex: "never_scheduled_gs",
            width: 130,
            align: "center",
            sorter: (a, b) => numberSorter(a, b, 'never_scheduled_gs'),

            render: (val) => <span>{val || 0}</span>,
        },
    ];

    useEffect(() => {
        fetchReportData();
    }, [dateFilter]);

    const fetchReportData = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = sessionStorage.getItem("token");

            if (!token) {
                setError("No authentication token found");
                return;
            }

            console.log("Fetching admin report...");

            const res = await getAdminDistrictSpecialGsReport(token, dateFilter);

            console.log("API Response:", res);

            const reportData = res?.result || [];

            const formatted = reportData.map((item, index) => ({
                ...item,
                key: item.district_code || `district-${index}`,
                sr_no: index + 1,
                quorum_fulfilled: item.quorum_fulfilled || 0,
                quorum_failed: item.quorum_failed || 0,
                district_code: item.district_code,
            }));

            setData(formatted);

            if (formatted.length > 0) {
                message.success(`Loaded ${formatted.length} district records`);
            } else {
                message.warning("No district data found");
            }

        } catch (err) {
            console.error("Fetch Error Details:", err);

            const errorMessage = err.message || "Failed to fetch report data";
            setError(errorMessage);
            message.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    // Update the openBlockModal function to pass district_code
    const openBlockModal = async (district) => {
        setBlockPage(1);
        setBlockPageSize(10);
        console.log('Opening block modal for district:', district.district_name);
        setBlockModalTitle(`Block-wise Report : ${district.district_name}`);
        setBlockModalOpen(true);
        setBlockData([]);
        setBlockLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setBlockLoading(false);
                return;
            }

            // Pass district_code to API
            const result = await getBlocksummaryforadmin(token, district.district_code);

            console.log("Block Summary API Result:", result);

            if (result.success) {
                const blockFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.block_code || `block-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_count: item.no_of_gram_panchayats || 0,
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                }));

                setBlockData(blockFormatted);
                message.success(`Loaded ${blockFormatted.length} blocks for ${district.district_name}`);
            } else {
                message.error(result.message || 'Failed to fetch block data');
            }
        } catch (err) {
            console.error('Error fetching block data:', err);
            message.error(err.message || 'Failed to fetch block data');
        } finally {
            setBlockLoading(false);
        }
    };

    const openGPFromDistrict = async (district) => {
        setGpPage(1);
        setGpPageSize(10);
        console.log('Opening GP modal for district:', district.district_name);
        setGpModalTitle(`Gram Panchayat-wise Report : ${district.district_name}`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            // नया API फंक्शन इस्तेमाल करें (सिर्फ district_code पास करें)
            const result = await getAdminGpSummaryReport(token, district.district_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    gp_count: item.no_of_gram_panchayats || 0,
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${district.district_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };

    const openGPFromBlock = async (block) => {
        setGpPage(1);
        setGpPageSize(10);
        setBlockModalOpen(false);
        console.log('Opening GP modal for block:', block.block_name);
        setGpModalTitle(`Gram Panchayat-wise Report : ${block.block_name} (${block.district_name})`);
        setGpModalOpen(true);
        setGpData([]);
        setGpLoading(true);

        try {
            const token = sessionStorage.getItem("token");

            if (!token) {
                message.error("No authentication token found");
                setGpLoading(false);
                return;
            }

            // नया API फंक्शन इस्तेमाल करें (district_code + block_code दोनों पास करें)
            const result = await getAdminGpSummaryReport(token, block.district_code, block.block_code);

            if (result.success) {
                const gpFormatted = result.result.map((item, index) => ({
                    ...item,
                    key: item.panchayat_code || `gp-${index}`,
                    sr_no: index + 1,
                    district_name: item.district_name,
                    block_name: item.block_name,
                    gp_name: item.panchayat_name || item.gp_name,
                    gp_count: item.no_of_gram_panchayats || 0,
                    gram_sabha_held: item.total_panchayats_gramsabha_held || 0,
                    quorum_fulfilled: item.quorum_fulfilled_count || 0,
                    quorum_failed: item.quorum_failed_count || 0,
                    never_scheduled_gs: item.never_scheduled_gramsabha || 0,
                    block_code: item.block_code,
                    panchayat_code: item.panchayat_code,
                }));

                setGpData(gpFormatted);
                message.success(`Loaded ${gpFormatted.length} gram panchayats for ${block.block_name}`);
            } else {
                message.error(result.message || 'Failed to fetch GP data');
            }
        } catch (err) {
            console.error('Error fetching GP data:', err);
            message.error(err.message || 'Failed to fetch GP data');
        } finally {
            setGpLoading(false);
        }
    };



    /* ================= EXPORT FUNCTIONS ================= */


    const handleExportPDF = () => {
        if (!data.length) return message.warning("No data to export");

        const doc = new jsPDF("landscape");
        doc.setFontSize(16);
        doc.text("District Admin Consolidated Report", 14, 16);

        // Use the imported 'autoTable' function
        autoTable(doc, {
            startY: 25,
            head: [columns.map((c) => c.title)],
            body: [
                ...data.map((row) => columns.map((c) => row[c.dataIndex] ?? "")),
                [
                    "GRAND TOTAL",
                    "",
                    grandTotals.block_count,
                    grandTotals.gp_count,
                    grandTotals.gram_sabha_held,
                    grandTotals.quorum_fulfilled,
                    grandTotals.quorum_failed,
                    grandTotals.never_scheduled_gs,
                ],
            ],

            styles: { fontSize: 8 },
            theme: "grid",
        });

        doc.save("District_Admin_Report.pdf");
        message.success("PDF exported");
    };

    const handleExportExcel = () => {
        if (!data.length) return message.warning("No data to export");

        const excelData = data.map((row, idx) => ({
            "Sr. No.": idx + 1,
            "District Name": row.district_name || "-",
            "No. of Blocks": row.block_count || 0,
            "No. of Gram Panchayats": row.gp_count || 0,
            "Gram sabha Held (including 1st,2nd & 3rd)": row.gram_sabha_held || 0,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": row.quorum_fulfilled || 0,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": row.quorum_failed || 0,
            "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
        }));

        excelData.push({
            "Sr. No.": "GRAND TOTAL",
            "District Name": "",
            "No. of Blocks": grandTotals.block_count,
            "No. of Gram Panchayats": grandTotals.gp_count,
            "Gram sabha Held (including 1st,2nd & 3rd)": grandTotals.gram_sabha_held,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": grandTotals.quorum_fulfilled,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": grandTotals.quorum_failed,
            "Never Scheduled Gram Sabha": grandTotals.never_scheduled_gs,
        });


        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "District Report");

        const fileName = `District_Admin_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        message.success("Excel file exported successfully");
    };

    const handleExportBlockExcel = () => {
        if (!blockData.length) return message.warning("No data to export");

        const excelData = blockData.map((row, idx) => ({
            "Sr. No.": idx + 1,
            "District Name": row.district_name || "-",
            "Block Name": row.block_name || "-",
            "No. of Gram Panchayats": row.gp_count || 0,
            "Gram Sabha Held (including 1st,2nd & 3rd)": row.gram_sabha_held || 0,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": row.quorum_fulfilled || 0,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": row.quorum_failed || 0,
            "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
        }));
        excelData.push({
            "Sr. No.": "GRAND TOTAL",
            "District Name": "",
            "Block Name": "",
            "No. of Gram Panchayats": blockGrandTotals.gp_count,
            "Gram Sabha Held (including 1st,2nd & 3rd)": blockGrandTotals.gram_sabha_held,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": blockGrandTotals.quorum_fulfilled,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": blockGrandTotals.quorum_failed,
            "Never Scheduled Gram Sabha": blockGrandTotals.never_scheduled_gs,
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Block Report");

        const fileName = `Block_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        message.success("Block Excel file exported successfully");
    };

    const handleExportGpExcel = () => {
        if (!gpData.length) return message.warning("No data to export");

        const excelData = gpData.map((row, idx) => ({
            "Sr. No.": idx + 1,
            "District Name": row.district_name || "-",
            "Block Name": row.block_name || "-",
            "Gram Panchayat Name": row.gp_name || "-",
            "Gram sabha Held (including 1st,2nd & 3rd)": row.gram_sabha_held || 0,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": row.quorum_fulfilled || 0,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": row.quorum_failed || 0,
            "Never Scheduled Gram Sabha": row.never_scheduled_gs || 0,
        }));
        excelData.push({
            "Sr. No.": "GRAND TOTAL",
            "District Name": "",
            "Block Name": "",
            "Gram Panchayat Name": "",
            "Gram sabha Held (including 1st,2nd & 3rd)": gpGrandTotals.gram_sabha_held,
            "Quorum Fulfilled (including 1st,2nd & 3rd meeting)": gpGrandTotals.quorum_fulfilled,
            "Quorum Failed (including 1st,2nd & 3rd meeting)": gpGrandTotals.quorum_failed,
            "Never Scheduled Gram Sabha": gpGrandTotals.never_scheduled_gs,
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "GP Report");

        const fileName = `GP_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
        message.success("GP Excel file exported successfully");
    };

    /* ================= CLICK STYLE ================= */
    const clickStyle = {
        color: "#1677ff",
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 500,
    };

    const grandTotals = {
        block_count: data.reduce((s, i) => s + (i.block_count || 0), 0),
        gp_count: data.reduce((s, i) => s + (i.gp_count || 0), 0),
        gram_sabha_held: data.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: data.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: data.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: data.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };

    const blockGrandTotals = {
        gp_count: blockData.reduce((s, i) => s + (i.gp_count || 0), 0),
        gram_sabha_held: blockData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: blockData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: blockData.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: blockData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };

    const gpGrandTotals = {
        gram_sabha_held: gpData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0),
        quorum_fulfilled: gpData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0),
        quorum_failed: gpData.reduce((s, i) => s + (i.quorum_failed || 0), 0),
        never_scheduled_gs: gpData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0),
    };

    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    return (
        <div className="report-container">
            <div style={{
                background: '#fff',
                padding: '24px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                marginBottom: '24px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <div>
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '600',
                            marginBottom: '4px',
                            color: '#1f1f1f'
                        }}>
                            Districtwise Status of Special Gram Sabha
                        </h2>
                        <p style={{
                            fontSize: '14px',
                            color: '#666',
                            margin: 0
                        }}>
                            Total Records: <strong>{data.length}</strong>
                        </p>
                    </div>

                    <Space>
                        <Button icon={<FilePdfOutlined />} onClick={handleExportPDF}>
                            Export PDF
                        </Button>
                        <Button
                            type="primary"
                            icon={<FileExcelOutlined />}
                            onClick={handleExportExcel}
                        >
                            Export Excel
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={fetchReportData}>
                            Refresh
                        </Button>
                    </Space>
                </div>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginBottom: '16px' }}
                    />
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="key"
                        bordered
                        size="small"
                        scroll={{ x: 1300, y: 420 }}
                        pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: data.length,
                            showSizeChanger: true,
                            showQuickJumper: false,
                            pageSizeOptions: ["10", "20", "50", "100"],
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} records`,
                        }}
                        onChange={handleTableChange}
                    />


                )}
            </div>
            {data.length > 0 && (
                <div
                    style={{
                        marginTop: 12,
                        padding: "10px 14px",
                        background: "#e6f7ff",
                        border: "1px solid #91d5ff",
                        borderRadius: 6,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 14,
                        fontSize: 13,
                    }}
                >
                    <span><strong>Grand Totals (All Pages):</strong></span>

                    <span>Blocks: <strong>{grandTotals.block_count}</strong></span>

                    <span>GPs: <strong>{grandTotals.gp_count}</strong></span>

                    <span>GS Held: <strong>{grandTotals.gram_sabha_held}</strong></span>

                    <span>Quorum Met: <strong>{grandTotals.quorum_fulfilled}</strong></span>

                    <span>Quorum Failed: <strong>{grandTotals.quorum_failed}</strong></span>

                    <span>Never Scheduled: <strong>{grandTotals.never_scheduled_gs}</strong></span>
                </div>
            )}


            {/* ========== BLOCK MODAL ========== */}


            <Modal
                open={blockModalOpen}
                onCancel={() => setBlockModalOpen(false)}
                width={1200}
                destroyOnClose
                footer={null}
                closable
                style={{ top: 20 }}
                bodyStyle={{
                    padding: '16px 0 0 0',
                    overflow: 'hidden'
                }}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ fontSize: 16, fontWeight: 600 }}>
                                {blockModalTitle}
                            </span>

                            <Button
                                type="primary"
                                icon={<FileExcelOutlined />}
                                onClick={handleExportBlockExcel}
                                disabled={blockLoading || blockData.length === 0}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                }
            >
                {blockLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                            Loading block data...
                        </p>
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(80vh - 110px)',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            paddingRight: '4px'
                        }}>
                            <Table
                                columns={blockColumns}
                                dataSource={blockData}
                                rowKey="key"
                                bordered
                                size="small"
                                scroll={{ x: 900 }}
                                pagination={{
                                    current: blockPage,
                                    pageSize: blockPageSize,
                                    total: blockData.length,
                                    showSizeChanger: true,
                                    pageSizeOptions: ["10", "20", "50", "100"],
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} blocks`,
                                }}
                                onChange={(pagination) => {
                                    setBlockPage(pagination.current);
                                    setBlockPageSize(pagination.pageSize);
                                }}
                            />
                        </div>

                        {/* 🔽 TOTALS MOVED BELOW TABLE */}
                        {!blockLoading && blockData.length > 0 && (
                            <div
                                style={{
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    background: "#f0f9ff",
                                    borderRadius: 6,
                                    border: "1px solid #bae0ff",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 14,
                                    fontSize: 13,
                                    flexShrink: 0
                                }}
                            >
                                <span><strong>Grand Totals (All Pages):</strong></span>
                                <span>Blocks: <strong>{blockData.length}</strong></span>

                                <span>Total GPs: <strong>{blockData.reduce((s, i) => s + (i.no_of_gram_panchayats || i.gp_count || 0), 0)}</strong></span>

                                <span>GS Held: <strong>{blockData.reduce((s, i) => s + (i.total_panchayats_gramsabha_held || i.gram_sabha_held || 0), 0)}</strong></span>

                                <span>Quorum Met: <strong>{blockData.reduce((s, i) => s + (i.quorum_fulfilled_count || i.quorum_fulfilled || 0), 0)}</strong></span>

                                <span>Quorum Failed: <strong>{blockData.reduce((s, i) => s + (i.quorum_failed_count || i.quorum_failed || 0), 0)}</strong></span>

                                <span>Never Scheduled: <strong>{blockData.reduce((s, i) => s + (i.never_scheduled_gramsabha || i.never_scheduled_gs || 0), 0)}</strong></span>
                            </div>
                        )}
                    </div>
                )}
            </Modal>

            {/* ========== GP MODAL ========== */}

            <Modal
                open={gpModalOpen}
                onCancel={() => setGpModalOpen(false)}
                width={1200}
                destroyOnClose
                footer={null}
                closable
                style={{ top: 20 }}
                bodyStyle={{
                    padding: '16px 0 0 0', // Bottom padding removed
                    overflow: 'hidden' // Modal body को overflow नहीं
                }}
                title={
                    <div style={{ paddingRight: 40 }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <span style={{ fontSize: 16, fontWeight: 600 }}>
                                {gpModalTitle}
                            </span>

                            <Button
                                type="primary"
                                icon={<FileExcelOutlined />}
                                onClick={handleExportGpExcel}
                                disabled={gpLoading || gpData.length === 0}
                            >
                                Export Excel
                            </Button>
                        </div>
                    </div>
                }
            >
                {gpLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                        <Spin size="large" />
                        <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
                            Loading Gram Panchayat data...
                        </p>
                    </div>
                ) : (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: 'calc(80vh - 110px)', // Height adjusted
                        overflow: 'hidden' // Parent overflow hidden
                    }}>
                        <div style={{
                            flex: 1,
                            overflowY: 'auto', // Only vertical scroll
                            overflowX: 'hidden', // Horizontal scroll hidden
                            paddingRight: '4px' // Small padding for scrollbar
                        }}>
                            <Table
                                columns={gpColumns}
                                dataSource={gpData}
                                rowKey="key"
                                bordered
                                size="small"
                                scroll={{ x: 900 }}
                                pagination={{
                                    current: gpPage,
                                    pageSize: gpPageSize,
                                    total: gpData.length,
                                    showSizeChanger: true,
                                    pageSizeOptions: ["10", "20", "50", "100"],
                                    showTotal: (total, range) =>
                                        `${range[0]}-${range[1]} of ${total} GPs`,
                                }}
                                onChange={(pagination) => {
                                    setGpPage(pagination.current);
                                    setGpPageSize(pagination.pageSize);
                                }}
                            />
                        </div>

                        {/* 🔽 TOTAL STRIP BELOW TABLE */}
                        {!gpLoading && gpData.length > 0 && (
                            <div
                                style={{
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    background: "#f0f9ff",
                                    borderRadius: 6,
                                    border: "1px solid #bae0ff",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 14,
                                    fontSize: 13,
                                    flexShrink: 0
                                }}
                            >
                                <span><strong>Grand Totals (All Pages):</strong></span>
                                <span>Total GPs: <strong>{gpData.length}</strong></span>

                                <span>GS Held: <strong>{gpData.reduce((s, i) => s + (i.gram_sabha_held || 0), 0)}</strong></span>

                                <span>Quorum Met: <strong>{gpData.reduce((s, i) => s + (i.quorum_fulfilled || 0), 0)}</strong></span>

                                <span>Quorum Failed: <strong>{gpData.reduce((s, i) => s + (i.quorum_failed || 0), 0)}</strong></span>

                                <span>Never Scheduled: <strong>{gpData.reduce((s, i) => s + (i.never_scheduled_gs || 0), 0)}</strong></span>
                            </div>
                        )}
                    </div>
                )}
            </Modal>

        </div>
    );
};

export default DistrictAdminReport;
















